export default __webpack_public_path__ + "static/media/git.ce67c1f2.png";